import {createModelSchema, alias, list} from "serializr";
import {SmartOfferBundle} from "../bundle-core/SmartOfferBundle";
import {SmartOfferBundleKind} from "../bundle-core/SmartOfferBundleKind";
import {SmartOfferChristmasConfig} from "@/modules/redactor/models/smart-offer/bundle-christmas/SmartOfferChristmasConfig";


export class SmartOfferBundleChristmas extends SmartOfferBundle {

    constructor() {
        super(SmartOfferBundleKind.CHRISTMAS);

        this._offers = [];
    }

    get offers() {
      return this._offers;
    }

    set offers(value) {
      this._offers = value;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new SmartOfferBundleChristmas());
        } else if (target instanceof SmartOfferBundleChristmas) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(SmartOfferBundleChristmas, {
  _offers: alias("offers", list(SmartOfferChristmasConfig.schema())),
});
